const workflow_scenario = [
  {
    label: 'Entry',
    value: 'entry',
    fields: [
      {
        label: 'Timestamp',
        uid: 'timestamp',
        type: 'date',
      },
      {
        label: 'Due date',
        uid: 'due_date',
        type: 'date',
      },
    ],
    options: [
      {
        label: 'First entry',
        value: 'first_time',
      },
      {
        label: 'Every entry',
        value: 'every_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
      },
    ],
  },
  {
    label: 'Exit',
    value: 'exit',
    options: [
      {
        label: 'First exit',
        value: 'first_time',
      },
      {
        label: 'Every exit',
        value: 'every_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
      },
    ],
    fields: [
      {
        label: 'Timestamp',
        uid: 'timestamp',
        type: 'date',
      },
      {
        label: 'Due date',
        uid: 'due_date',
        type: 'date',
      },
      {
        label: 'Duration',
        uid: 'duration',
        type: 'number',
      },
      {
        label: 'Outcome',
        uid: 'outcome',
        type: 'text',
      },
    ],
  },
];

const non_workflow_scenario = [
  {
    label: 'Request for resubmission',
    value: 'request_for_resubmission',
    condition: 'has_submitters',
    fields: [
      {
        label: 'Timestamp',
        uid: 'timestamp',
        type: 'date',
      },
      {
        label: 'Submission due date',
        uid: 'submission_due_date',
        type: 'date',
        condition: 'has_submitters',
      },
    ],
    options: [
      {
        label: 'Every submission',
        value: 'every_time',
      },
      {
        label: 'First submission',
        value: 'first_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
        condition: 'has_submitters',
      },
    ],
  },
  {
    label: 'Publish',
    value: 'publish',
    fields: [
      {
        label: 'Published at',
        uid: 'published_at',
        type: 'date',
      },
      {
        label: 'Published by',
        uid: 'published_by',
        type: 'members',
      },
      {
        label: 'Transmittal number',
        uid: 'transmittal_number',
        type: 'number',
      },
      {
        label: 'Transmittal due date',
        uid: 'transmittal_due_date',
        type: 'date',
      },
      {
        label: 'Submission planned duration',
        uid: 'submission_planned_duration',
        type: 'number',
        condition: 'has_submitters',
      },
      {
        label: 'Submission due date',
        uid: 'submission_due_date',
        type: 'date',
        condition: 'has_submitters',
      },
      {
        label: 'Review planned duration',
        uid: 'review_planned_duration',
        type: 'number',
        condition: 'has_reviewers',
      },
    ],
    options: [],
  },
  {
    label: 'Submission',
    value: 'submission',
    condition: 'has_submitters',
    fields: [
      {
        label: 'Submission actual duration',
        uid: 'submission_actual_duration',
        type: 'number',
        condition: 'has_submitters',
      },
      {
        label: 'Submission date',
        uid: 'submission_date',
        type: 'date',
        condition: 'has_submitters',
      },
      {
        label: 'Review due date',
        uid: 'review_due_date',
        type: 'date',
        condition: 'has_reviewers',
      },
      {
        label: 'Approve due date',
        uid: 'approve_due_date',
        type: 'date',
        condition: 'has_approvers',
      },
      {
        label: 'Revision number',
        uid: 'revision_number',
        type: 'text',
      },
      {
        label: 'Date on document',
        uid: 'date_on_document',
        type: 'date',
      },
    ],
    options: [
      {
        label: 'Every submission',
        value: 'every_time',
      },
      {
        label: 'First submission',
        value: 'first_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
        condition: 'has_submitters',

      },
    ],
  },
  {
    label: 'Review completion',
    value: 'review_completion',
    condition: 'has_reviewers',
    fields: [
      {
        label: 'Review date',
        uid: 'review_date',
        type: 'date',
        condition: 'has_reviewers',
      },
      {
        label: 'Review actual duration',
        uid: 'review_actual_duration',
        type: 'number',
        condition: 'has_reviewers',
      },
    ],
    options: [
      {
        label: 'Every review cycle',
        value: 'every_time',
      },
      {
        label: 'First review cycle',
        value: 'first_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
        condition: 'has_submitters',
      },
    ],
    remarks: 'Calculate/Trigger this only when the final decision is taken',
  },
  {
    label: 'Approval completion',
    value: 'approval_completion',
    condition: 'has_approvers',
    fields: [
      {
        label: 'Approve date',
        uid: 'approve_date',
        type: 'date',
        condition: 'has_approvers',
      },
      {
        label: 'Approve actual duration',
        uid: 'approve_actual_duration',
        type: 'number',
        condition: 'has_approvers',
      },
    ],
    options: [
      {
        label: 'Every approve',
        value: 'every_time',
      },
      {
        label: 'First approve',
        value: 'first_time',
      },
      {
        label: 'Each revision',
        value: 'each_revision',
        condition: 'has_submitters',
      },
    ],
  },
  {
    label: 'Sync',
    value: 'sync',
    fields: [
      {
        label: 'Synced at',
        uid: 'synced_at',
        type: 'date',
      },
    ],
    options: [],
  },
  {
    label: 'Close',
    value: 'close',
    fields: [
      {
        label: 'Closed at',
        uid: 'closed_at',
        type: 'date',
      },
    ],
    options: [],
  },
  {
    label: 'Cancel',
    value: 'cancel',
    fields: [
      {
        label: 'Cancelled at',
        uid: 'cancelled_at',
        type: 'date',
      },
    ],
    options: [],
  },
];

export const custom_field_mapping_scenario = {
  workflow: workflow_scenario,
  non_workflow: non_workflow_scenario,
};
